import CalculationResultInterface from '@/utilities/bid/cost/Interfaces/CalculationResultInterface'
import SummaryCollectionInterface from '@/utilities/bid/cost/Interfaces/SummaryCollectionInterface'
import CollectionInterface from '@/utilities/bid/cost/Interfaces/CollectionInterface'
import Calculation from '@/utilities/bid/cost/Calculation'
import CalculatedDetailsInterface from '@/utilities/bid/cost/Interfaces/CalculatedDetailsInterface'
import CollectionEnum from '@/utilities/bid/cost/enums/CollectionEnum'
import cloneDeep from 'lodash/cloneDeep'

class SummaryTable {
  details: CalculatedDetailsInterface
  totals: Array<CalculationResultInterface> = []
  percent: number = 0
  collection: Array<SummaryCollectionInterface> = []

  constructor(details: CalculatedDetailsInterface, totals: Array<CalculationResultInterface>) {
    this.details = details
    this.totals = totals
  }

  updateTotal(totals: Array<CalculationResultInterface>) {
    this.totals = totals
  }

  getCost(collection: Array<CollectionInterface>): number {
    const calculation = new Calculation(collection)
    calculation.columnTotal(collection)
    return calculation.getTotalValue()
  }

  getTotalCostBy(reference: string, collection: Array<CollectionInterface>): number {
    const index = this.totals.findIndex(item => item.ref === reference)
    return index > -1 ? this.totals[index].total : this.getCost(collection)
  }

  getMarginValue(item: SummaryCollectionInterface): number {
    return parseFloat((item.cost / (1 - item.percent / 100) - item.cost).toFixed(4))
  }

  getFee(item: SummaryCollectionInterface): number {
    return parseFloat((item.cost + item.value).toFixed(4))
  }

  setPercentage(value: number = 0, item: SummaryCollectionInterface) {
    item.percent = value
    item.value = this.getMarginValue(item)
    item.fee = this.getFee(item)
    const index = this.collection.findIndex(element => element.key === item.key)
    this.collection[index] = item
  }

  getAll(): Array<SummaryCollectionInterface> {
    this.collection = [
      {
        key: CollectionEnum.LABOUR,
        title: 'Direct Labour',
        cost: this.getTotalCostBy(CollectionEnum.LABOUR, this.details.labour),
        percent: 0,
        value: 0,
        fee: 0,
      },
      {
        key: CollectionEnum.PROCESSING,
        title: 'Data Processing',
        cost: this.getTotalCostBy(CollectionEnum.PROCESSING, this.details.processing),
        percent: 0,
        value: 0,
        fee: 0,
      },
      {
        key: CollectionEnum.EXPENSES,
        title: 'Expenses',
        cost: this.getTotalCostBy(CollectionEnum.EXPENSES, this.details.expenses),
        percent: 0,
        value: 0,
        fee: 0,
      },
      {
        key: CollectionEnum.ADDITIONAL,
        title: 'Additional Cost',
        cost: this.getTotalCostBy(CollectionEnum.ADDITIONAL, this.details.additional),
        percent: 0,
        value: 0,
        fee: 0,
      },
    ]

    return this.collection
  }

  updateOne(collection: CalculationResultInterface, summary: Array<SummaryCollectionInterface>): SummaryCollectionInterface {
    const index = summary.findIndex(element => element.key === collection.ref)
    const item = cloneDeep(summary[index])
    item.cost = collection.total
    item.value = this.getMarginValue(item)
    item.fee = this.getFee(item)
    return item
  }

  updatePercent(percent: number = 0, summary: Array<SummaryCollectionInterface>) {
    const collection: Array<SummaryCollectionInterface> = []
    summary.forEach(element => {
      const item = cloneDeep(element)
      item.percent = percent
      item.value = this.getMarginValue(item)
      item.fee = this.getFee(item)
      collection.push(item)
    })
    return collection
  }
}

export default SummaryTable
